var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChildComponentOptions } from '../childComponentOptions';
import { ChildComponentType } from '../childComponentType';
/**
 * Cross Window Child Component Options.
 */
var CrossWindowChildComponentOptions = /** @class */ (function (_super) {
    __extends(CrossWindowChildComponentOptions, _super);
    /**
     * Constructor.
     */
    function CrossWindowChildComponentOptions() {
        var _this = _super.call(this) || this;
        _this.url = 'about:blank';
        _this.type = ChildComponentType.CrossWindow;
        return _this;
    }
    return CrossWindowChildComponentOptions;
}(ChildComponentOptions));
export { CrossWindowChildComponentOptions };
//# sourceMappingURL=childComponentOptions.js.map